import { hasSource, Memo, MemoType } from 'models/Memo';
import { UseFormReturn } from 'react-hook-form';
import { FormValues } from './useFormInitialisation';
import { useToggleableField } from './useToggleableField';

interface Props {
  memo?: Memo;
  methods: UseFormReturn<FormValues>;
  selectedMemoType: MemoType;
}

export const useSource = ({ memo, methods, selectedMemoType }: Props) => {
  const canShowSource = [MemoType.Text, MemoType.Quote].includes(
    selectedMemoType,
  );

  const hasInitialValue = !!(memo && hasSource(memo) && memo.source?.content);

  const { isVisible, toggle } = useToggleableField({
    fieldName: 'source',
    methods,
    canShow: canShowSource,
    hasInitialValue,
  });

  return {
    canShowSource,
    isSourceVisible: isVisible,
    toggleSource: toggle,
  };
};
